import { useState } from "react";
import { Linkedin, MessageCircle, Mail, Link2, Check } from "lucide-react";
import { toast } from "sonner";

// Reusable social-sharing row for article pages.
export const ShareBar = ({ title }) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title || "");

  const links = [
    {
      key: "linkedin",
      label: "Share on LinkedIn",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      Icon: Linkedin,
    },
    {
      key: "whatsapp",
      label: "Share on WhatsApp",
      href: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
      Icon: MessageCircle,
    },
    {
      key: "email",
      label: "Share by email",
      href: `mailto:?subject=${encodedTitle}&body=${encodedTitle}%0A%0A${encodedUrl}`,
      Icon: Mail,
    },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Link copied to clipboard");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      data-testid="article-share-bar"
      className="flex items-center gap-3 flex-wrap"
    >
      <span className="font-sans text-[11px] tracking-[0.2em] uppercase text-charcoal/45 mr-1">
        Share
      </span>
      {links.map(({ key, label, href, Icon }) => (
        <a
          key={key}
          data-testid={`share-${key}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
          className="inline-flex items-center justify-center w-10 h-10 border border-charcoal/20 text-charcoal/70 hover:border-forest hover:text-forest transition-colors duration-300"
        >
          <Icon className="w-4 h-4" strokeWidth={1.6} />
        </a>
      ))}
      <button
        type="button"
        data-testid="share-copy-link"
        onClick={copyLink}
        aria-label="Copy link"
        title="Copy link"
        className="inline-flex items-center gap-2 font-sans text-[11px] tracking-[0.14em] uppercase px-4 h-10 border border-charcoal/20 text-charcoal/70 hover:border-forest hover:text-forest transition-colors duration-300"
      >
        {copied ? <Check className="w-4 h-4 text-forest" strokeWidth={2} /> : <Link2 className="w-4 h-4" strokeWidth={1.6} />}
        {copied ? "Copied" : "Copy Link"}
      </button>
    </div>
  );
};
